<template>
  <div>
    <!-- <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="基本数据">
        <div class="tab_box">
          <tabOneSum :fissionId="fissionId"></tabOneSum>
          <tabOneList :fissionId="fissionId"></tabOneList>
        </div>
      </a-tab-pane>
      <a-tab-pane class="tab_box" key="2" tab="员工数据" force-render>
        <tabTwoList :fissionId="fissionId"></tabTwoList>
      </a-tab-pane>
      <a-tab-pane class="tab_box" key="3" tab="客户数据">
        <tabThreeList :fissionId="fissionId"></tabThreeList>
      </a-tab-pane>
      <a-button slot="tabBarExtraContent" @click="goBack">
        返回
      </a-button>
    </a-tabs> -->
    <!-- <div class="backBtn">
      <a-button size="small" @click="goBack">
        返回
      </a-button>
    </div> -->
    <el-tabs class="tabsClass">
      <el-tab-pane label="基本数据">
        <tabOneSum :fissionId="fissionId"></tabOneSum>
        <tabOneList :fissionId="fissionId"></tabOneList>
      </el-tab-pane>
      <el-tab-pane label="员工数据">
        <tabTwoList :fissionId="fissionId"></tabTwoList>
      </el-tab-pane>
      <el-tab-pane label="客户数据">
        <tabThreeList :fissionId="fissionId"></tabThreeList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import tabOneSum from "./detail/tabOneSum";
import tabOneList from "./detail/tabOneList";
import tabTwoList from "./detail/tabTwoList";
import tabThreeList from "./detail/tabThreeList";
export default {
  props: ['fissionId'],
  data() {
    return {
      // fissionId: this.$route.query.id ? this.$route.query.id : 1,
    };
  },
  components:{
    tabOneSum,
    tabOneList,
    tabTwoList, //员工数据
    tabThreeList,
  },
  methods: {
    callback(key) {
      console.log(key);
    },
    goBack(){
      this.$router.back()
    }
  },
};
</script>
<style lang="less" scoped>
.tab_box{
  width: 100%;
  background-color: #fff;
  padding: 20px 12px;
}

</style>